$(function () {

  //sp-sub-nav
  var str = $('.sp-category-links');
  $('.category-btn a').on('click', function () {
    $('body').toggleClass('is__fixed');
    str.fadeToggle();
    return false;
  });
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.sp-category-links').length) {
      str.fadeOut();
      $('body').removeClass('is__fixed');
    }
  });
  $('.has-children').on('click', function () {
    $(this).toggleClass('open');
    $(this).next().slideToggle();
  });

  // ranking section
  $('.tab_label').on('click', function () {
    var $th = $(this).index();
    $('.tab_label').removeClass('active');
    $('.tab_panel').removeClass('active');
    $(this).addClass('active');
    $('.tab_panel').eq($th).addClass('active');
  });

  // $('.collection-ranking .tab_panel .rankin-badge').each(function(i){
  //   $(this).text((i+1));
  // });
  $('.ranking-list .rankin-badge').each(function (i) {
    $(this).text((i + 1));
  });


  $('#btn_container').insertBefore('.add-to-cart').css('margin-bottom', '30px');


  $('.accordion-headline').on('click', function () {
    $(this).toggleClass('is-open');
    $(this).next().toggleClass('is-open');
  });
});

$(function () {
  var headerH = $('.site-header').innerHeight();
  $('a[href^="#"]').on('click', function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href === "#" || href === "" ? 'html' : href);
    var position = target.offset().top - headerH;
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });

  $(window).on('load scroll', function () {
    var scroll = $(window).scrollTop();
    var scrollHeight = $(document).height();
    var scrollPosition = $(window).height() + scroll;
    var footHeight = $('.site-footer').innerHeight();
    var sp_stop = footHeight + 5;
    var pc_stop = footHeight + 20;
    var ico = $('.pagetop');
    if (scrollHeight - scrollPosition <= footHeight) {
      if (matchMedia('(max-width: 798px)').matches) {
        ico.css({
          "position": "absolute",
          "bottom": sp_stop
        });
      } else {
        ico.css({
          "position": "absolute",
          "bottom": pc_stop
        });
      }
    } else {
      ico.css({
        "position": "fixed",
        "bottom": "24px"
      });
    }
    if ($(this).scrollTop() > 200) {
      $('.pagetop').fadeIn();
    } else {
      $('.pagetop').fadeOut();
    }
  });

});
$(function () {
  $('.accordion-nav .js-accordion').on('click', function () {
    $(this).toggleClass('on');
    $(this).next('.js-guide-menu').slideToggle();
    $('.accordion-nav .js-accordion').not($(this)).removeClass('on');
    $('.accordion-nav .js-accordion').not($(this)).next('.js-guide-menu').slideUp();
    return false;
  });

});

// guide fix
$(function () {
  if (window.matchMedia('(min-width:769px)').matches) {
    var nav = $('.accordion-nav');
    var navH = nav.innerHeight();
    $(window).on('load scroll', function () {
      var scroll = $(window).scrollTop();
      $('.guide-contents').each(function () {
        var area = $('.guide-contents').outerHeight(); //
        var startPos = $('.guide-contents').offset().top - 100;
        var endPos = $('.guide-contents').offset().top + area - navH;
        var change = $('.guide-contents').offset().top + area;

        if (scroll > startPos && scroll < endPos) {
          nav.addClass('is__fixed');
          nav.removeClass('btm');
        } else if (scroll > endPos && scroll < change) {
          nav.addClass('btm');
        } else {
          nav.removeClass('is__fixed btm');
        }
      });
    });
  }
});

//collection-sidebar
// $(window).on('load', function(){
//   $('.boost-pfs-filter-option-colour .boost-pfs-filter-option-title-text').text('カラー');
// });
$(function () {
  function playPauseVideo(slick, control) {
    var currentSlide, video;
    currentSlide = slick.find(".slick-current");
    video = currentSlide.find("video").get(0);
    if (video != null) {
      if (control === "play") {
        video.play();
      } else {
        video.pause();
      }
    }
  }

  var product_main = "#AwProductPhotos";
  var product_thumb_item = "#AwProductThumbs .product__thumb-item";
  $(product_thumb_item).each(function () {
    var index = $(product_thumb_item).index(this);
    $(this).attr("data-index", index);
  });
  $(product_main).on('init', function (slick) {
    var index = $(".slide-item.slick-slide.slick-current").attr("data-slick-index");
    $(product_thumb_item + '[data-index="' + index + '"]').addClass("thumbnail-current");
  });
  $(product_main).slick({
    autoplay: false,
    arrows: true,
    fade: true,
    infinite: false,
    adaptiveHeight: true
  });

  $(product_thumb_item).on('click', function () {
    var index = $(this).attr("data-index");
    $(product_main).slick("slickGoTo", index, false);
  });

  $(product_main).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $(product_thumb_item).each(function () {
      $(this).removeClass("thumbnail-current");
    });
    $(product_thumb_item + '[data-index="' + nextSlide + '"]').addClass("thumbnail-current");
    slick = $(slick.$slider);
    playPauseVideo(slick, "pause");
  });
  $(product_main).on('afterChange', function (event, slick, currentSlide, nextSlide) {
    slick = $(slick.$slider);
    currentSlide = slick.find(".slick-current");
    playPauseVideo(slick, "play");
  });


  $('.variant-input input').on('change', function () {
    var thumbnailImg;

    thumbnailImg = $(this).data('color-image');
    if (thumbnailImg) {
      thumbnailImg = thumbnailImg.match(".+/(.+?)\.[a-z]+([\?#;].*)?$")[1];
    }
    $('#AwProductPhotos .slick-track .slick-slide').each(function () {
      var slideImg = $(this).find('img').get(0).currentSrc;
      if (slideImg) {
        slideImg = slideImg.match(".+/(.+?)\.[a-z]+([\?#;].*)?$")[1];
      }
      if (slideImg.indexOf(thumbnailImg) > -1) {
        var index = $(this).attr("data-index");
        $(product_main).slick("slickGoTo", index, false);
      }
    });
  });

});

// $(function () {
//   if (matchMedia('(min-width: 768px)').matches) {
//     var $thumbs = $('.product__thumbs'),
//       emptyCells = [],
//       i;
//     for (i = 0; i < $thumbs.find('.product__thumb-item').length; i++) {
//       emptyCells.push($('<div>', { class: 'product__thumb-item is-empty' }));
//     }
//     $thumbs.append(emptyCells);
//   }



// });
